export const brandname = "SodiumBox";
